


























import BaseLoading from '@/components/base/BaseLoading.vue';
import SiteWrapper from '@/components/SiteWrapper.vue';
import { PublicCourseDetails } from '@/jbi-shared/dto/jtms-public-course.dtos';
import BaseButton from '@/jbi-shared/vue-components/BaseButton.vue';
import { RootState } from '@/store/store';
import { Component, Vue } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
import CheckoutSteps from '../components/CheckoutSteps.vue';
import PurchaseOrderSummary from '../components/PurchaseOrderSummary.vue';
import CheckoutLayout from '../layout/CheckoutLayout.vue';

@Component({
  components: {
    BaseButton,
    BaseLoading,
    SiteWrapper,
    CheckoutLayout,
    CheckoutSteps,
    PurchaseOrderSummary
  }
})
export default class ShortCoursesCheckoutPage extends Vue {
  @Getter('course/isFreeCourse')
  isFreeCourse!: boolean;

  @State(({ course }: RootState) => course.publicCourseState.courseDetails)
  publicCourseDetails!: PublicCourseDetails;

  @State(({ shortCourseCheckout }: RootState) => shortCourseCheckout.isLastStep)
  isLastStep!: PublicCourseDetails;

  courseSlug: string = '';
  currentStep: number = 0;

  created() {
    // ASSUMPTION (if state is reset, redirect to public courses page):
    // This runs immediately when the component tries to mount (i.e., if user refreshes page)
    // If the user refreshed the page, Vuex state is usually wiped (unless persisted).
    // This code block checks if data exists; if not, we yeet them out before the UI renders.
    if (!this.publicCourseDetails) {
      const splitPaths = window.location.pathname.split('/');
      this.courseSlug = splitPaths.pop()!;

      this.$router.replace({
        name: 'ShortCourses',
        params: {
          slug: this.courseSlug
        }
      });
    }
  }

  handleNextStep() {
    if (!this.isLastStep) {
      // JAAS-2803-TODO:
      // Ideally, add custom validations here on forms before allowing user to proceed to
      // next step. Letting them proceed as usual for now
      if (true) {
        this.currentStep++;
      }
    }
  }

  handleBack() {
    if (this.currentStep > 0) {
      this.currentStep--;
    } else {
      this.$router.back();
    }
  }
}
